<template>
  <div class="nzm_imgs" >
    <template v-if="show_type==='m01' || show_type==='m02' || show_type==='m03'">
      <div v-for="(rowItem, rowId) in data_list" :key="'row_'+rowId" class="row">
      <div
        v-for="(item, itemId) in rowItem"
        :key="'item_'+  rowId + '_'+ itemId"
        :class="[!item.title && !item.sub_title ? 'no-text' : '','img_block']"
        :style="block_style"
      >
        <img class="img_content" v-lazy="item.img" @click.prevent="click_item($event,item)" :style="getNzmWrapStyle(info)"/>
        <div class="icon" v-if="item.icon">
          <CoverIcon :info="item.icon"/>
        </div>
        <div class="m5_info">
          <div v-if="item.title" :style="textMainColorStyle" class="title">{{item.title}}</div>
          <div v-if="item.sub_title" :style="textSubColorStyle" class="sub_title">{{item.sub_title}}</div>
        </div>
      </div>
    </div>
    </template>
    <template v-else>
      <!-- 三图 四图 五图特定样式 -->
      <div class="list-wrap">
        <div
          v-for="(item, itemId) in data_list"
          :key="itemId"
          :class="[`style-${show_type}`,'img_block']"
        >
          <img class="img_content" v-lazy="item.img" @click.prevent="click_item($event,item)" :style="getNzmWrapStyle(info)"/>
          <div class="icon" v-if="item.icon">
            <CoverIcon :info="item.icon"/>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { getJSON, getJSONP } from "../../api/myaxios";
import { openLink } from "../../tools/mgtv/link";
import click_handler from "../../tools/mgtv/click";
import { toRem, urlToWebp } from "../../tools/tpl";
import { group_by_size } from "../../tools/group";
import handle_action from "../../tools/mgtv/action";
import { HIDE_COMP } from '../../constant/eventbus'
import  CoverIcon from './CoverIcon'
import {getNzmWrapStyle} from '../../tools/mgtv/nzmWrapStyle'

const type_configs = {
  m01: {
    width: "7.1rem",
    margin: "0 0.1rem",
    row_size: 1,
  },
  m02: {
    width: "3.5rem",
    margin: "0 0.075rem",
    row_size: 2
  },
  m03: {
    width: "2.3rem",
    margin: "0 0.06rem",
    row_size: 3
  }
};

// 图文控件
export default {
  name: "NzmImgMultiLine",
  components: {CoverIcon},
  props: {
    info: {
      type: Object
    }
  },
  data: function() {
    return {
      data_list: null
    };
  },
  methods: {
    getNzmWrapStyle,
    get_detail() {
      getJSON(
        "//vipact3.api.mgtv.com/api/v1/act/img/get",
        {
          act_name: this.info.act_name,
          invoker: window.gact.invoker,
          f_release: window.gact.f_release
        },
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          let list = res.data.list;
          if(list.length === 0){
            console.log('没有内容，隐藏模块', this.info.act_name)
            window.$bus.$emit(HIDE_COMP, this.info.act_name);
            return;
          }
          list.forEach(item => {
            item.img = urlToWebp(item.img);
          });
          list = list.slice(0, this.max_num);
          switch(this.show_type){
            case 'm01':
            case 'm02':
            case 'm03':
              this.data_list = group_by_size(
              list,
              type_configs[this.show_type]["row_size"]
            ); //自动换行
              break;
            case 'm04':
              this.data_list = list.slice(0,3)
              break;
            case 'm05':
              this.data_list = list.slice(0,4)
              break;
            case 'm06':
              this.data_list = list.slice(0,5)
              break;
          }
        }
      });
    },
    click_item($event, item) {
      // console.log(item);
      click_handler(`${this.info.act_name_chn}-点击-${item.id}`, () => {
        handle_action(item);
      });
    }
  },
  mounted() {
    this.get_detail();
  },
  computed: {
    show_type: function() {
      return this.info.config.show_type || "m01";
    },
    config: function() {
      return type_configs[this.show_type] || {};
    },
    block_style() {
      return {
        width: this.config.width || "7.1rem",
        margin: this.config.margin || "0"

      };
    },
    max_num: function () {
      return this.info.config.max_num || 999999;
    },
    textMainColorStyle:function(){
      return window.$bus.textMainColorStyle
    },
    textSubColorStyle:function(){
      return window.$bus.textSubColorStyle
    }
  }
};
</script>


<style lang="stylus" scoped>
  @import "../../share/mixins.styl"
  .nzm_imgs
    position relative
    width 7.5rem
    display flex
    flex-direction column
    .row
      position relative
      padding 0 0.1rem
      display flex
      width 7.5rem
      margin-bottom .44rem
      @media screen and (min-width: 700px)
        margin-bottom 15PX
    .img_block
      position relative
      &.no-text
        margin-bottom:-0.3rem !important
      .icon
        position absolute
        top .1rem
        right .1rem
      .img_content
        width 100%
        border-radius .05rem
        display block
      .title
        width 100%
        font-size .28rem
        color #333333
        ellipsis()
        margin-top .2rem
        @media screen and (min-width: 700px)
          font-size 14PX
      .sub_title
        width 100%
        font-size .24rem
        color #969696
        ellipsis()
        margin-top .12rem
        @media screen and (min-width: 700px)
          font-size 12PX
    .list-wrap
      text-align: center
    .style-m04
      width: 3.38rem
      display: inline-block
      overflow hidden
      vertical-align: top
      .img_content
          width 100%
          display block
          border-radius: 0
      &.style-m04:nth-child(1)
        width: 6.9rem
        margin: 0 auto 0.14rem
        border-radius .16rem .16rem 0 0
      &.style-m04:nth-child(2)
        margin-right: 0.14rem
        border-radius 0 0 0 .16rem
      &.style-m04:nth-child(3)
        border-radius   0 0 .16rem 0
    .style-m05
      width: 2.2rem
      display: inline-block
      overflow hidden
      vertical-align: top
      .img_content
          width 100%
          border-radius 0
          // display block
          height: auto
          vertical-align: top
      &.style-m05:nth-child(1)
        width: 6.9rem
        margin: 0 auto 0.14rem
        border-radius .16rem .16rem 0 0
      &.style-m05:nth-child(2)
        border-radius 0 0 0 .16rem
      &.style-m05:nth-child(3)
        margin:  0 0.15rem
      &.style-m05:nth-child(4)
        border-radius   0 0 .16rem 0
    .style-m06
      display: inline-block
      overflow hidden
      width: 2.2rem
      vertical-align: top
      .img_content
          width 100%
          border-radius 0
          display block
      &.style-m06:nth-child(1)
        width: 3.38rem
        border-radius .16rem 0 0 0
        margin-right: 0.14rem
        margin-bottom: 0.14rem
      &.style-m06:nth-child(2)
        width: 3.38rem
        border-radius 0 .16rem 0 0
      &.style-m06:nth-child(3)
        border-radius 0 0 0 .16rem
      &.style-m06:nth-child(4)
        margin:  0 0.15rem
      &.style-m06:nth-child(5)
        border-radius   0 0 .16rem 0
</style>
